/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const MobileBookingSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M4.125 5.41309V5.41309C3.02043 5.41309 2.125 6.30852 2.125 7.41309V14.4131C2.125 15.5177 3.02043 16.4131 4.125 16.4131V16.4131"
      stroke="#FE921D"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M8.125 5.41309V5.41309C9.22957 5.41309 10.125 6.30852 10.125 7.41309V14.4131C10.125 15.5177 9.22957 16.4131 8.125 16.4131V16.4131"
      stroke="#FE921D"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <circle
      cx={17.125}
      cy={12.4131}
      r={3.25}
      stroke="#FE921D"
      strokeWidth={1.5}
    />
    <path
      d="M6.125 16.504V16.504C6.125 19.2152 8.32287 21.4131 11.0341 21.4131H11.625C14.6626 21.4131 17.125 18.9507 17.125 15.9131V15.9131"
      stroke="#FE921D"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <circle cx={17.125} cy={12.4131} r={1} fill="#FE921D" />
  </svg>
)
const ForwardRef = forwardRef(MobileBookingSvg)
export default ForwardRef
